import {
  RESET_FEATURES,
  RESET_FEATURE,
  RESET_ERROR,
  GET_FEATURES,
  SET_FEATURES,
  API_ERROR,
  CREATE_FEATURE,
  CREATE_FEATURE_SUCCESS,
  GET_FEATURE,
  SET_FEATURE,
  EDIT_FEATURE,
  EDIT_FEATURE_SUCCESS,
  DELETE_FEATURE,
  DELETE_FEATURE_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorFeature: false,
  loadingFeature: false,
  dataFeature: null,
  successFeature: false,
};

const Feature = (state = initialState, action) => {
  switch (action.type) {
    case RESET_FEATURES:
      state = {
        ...state,
        errorFeature: false,
        loadingFeature: false,
        loadingFeatureDelete: false,
        successFeature: false,
        dataFeature: null,
        dataFeatureDelete: null,
      };
      break;
    case RESET_FEATURE:
      state = {
        ...state,
        errorFeature: false,
        loadingFeature: false,
        successFeature: false,
        dataFeatureGetSet: null,
        dataFeatureEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorFeature: false,
        loadingFeature: false,
        loadingFeatureEditCreate: false,
        loadingFeatureActivate: false,
        successFeature: false,
      };
      break;
    case GET_FEATURES:
      state = {
        ...state,
        errorFeature: false,
        loadingFeature: true,
        dataFeature: null,
      };
      break;
    case SET_FEATURES:
      state = {
        ...state,
        errorFeature: false,
        loadingFeature: false,
        dataFeature: action.payload,
      };
      break;
    case CREATE_FEATURE:
      state = {
        ...state,
        errorFeature: false,
        loadingFeatureEditCreate: true,
        dataFeatureEditCreate: action.payload,
        successFeature: false,
      };
      break;
    case CREATE_FEATURE_SUCCESS:
      state = {
        ...state,
        errorFeature: false,
        loadingFeatureEditCreate: false,
        dataFeatureEditCreate: action.payload,
        successFeature: true,
      };
      break;
    case GET_FEATURE:
      state = {
        ...state,
        errorFeature: false,
        loadingFeature: true,
        dataFeatureGetSet: null,
      };
      break;
    case SET_FEATURE:
      state = {
        ...state,
        errorFeature: false,
        loadingFeature: false,
        dataFeatureGetSet: action.payload,
      };
      break;
    case EDIT_FEATURE:
      state = {
        ...state,
        errorFeature: false,
        loadingFeatureEditCreate: true,
        dataFeatureEditCreate: action.payload,
        successFeature: false,
      };
      break;
    case EDIT_FEATURE_SUCCESS:
      state = {
        ...state,
        errorFeature: false,
        loadingFeatureEditCreate: false,
        dataFeatureEditCreate: action.payload,
        successFeature: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorFeature: action.payload,
        loadingFeature: false,
        loadingFeatureDelete: false,
        successFeature: false,
      };
      break;
    case DELETE_FEATURE:
      state = {
        ...state,
        errorFeature: false,
        loadingFeatureDelete: true,
        dataFeatureDelete: action.payload,
        successFeature: false,
      };
      break;
    case DELETE_FEATURE_SUCCESS:
      state = {
        ...state,
        errorFeature: false,
        loadingFeatureDelete: false,
        dataFeatureDelete: action.payload,
        successFeature: true,
      };
      break;
    default:
      // state = { ...state, errorFeature: false, loadingFeature: false };
      break;
  }
  return state;
};

export default Feature;
